module.exports = __webpack_public_path__ + "static/media/classIcon.6ea3d56b.png";